import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { About } from './routes/pages/About';
import { CaseStudyDta } from './routes/pages/CaseStudyDta';
import { Contact } from './routes/pages/Contact';
import { BiddingEngine, LienLawCompliance } from './routes/pages/Features';
import { Home } from './routes/pages/Home';
import {
  AntiqueAuctionSoftware,
  CollectiblesAuctionSoftware,
  EstateAuctionSoftware,
  StorageAuctionSoftware,
} from './routes/pages/Niches';
import { NotFound } from './routes/pages/NotFound';
import { Pricing } from './routes/pages/Pricing';
import { Privacy } from './routes/pages/Privacy';
import { SubscriberAgreement } from './routes/pages/SubscriberAgreement';
import { Terms } from './routes/pages/Terms';
import {
  ForAuctionHouses,
  ForFacilities,
  ForLiquidators,
  ForSpecialty,
} from './routes/pages/Segments';

/**
 * Marketing site for auctisync.com — Option B+ scope per BUILD_PLAN.
 *
 * 15 pages live in this build:
 *   /                                   Home — segmented-horizontal hero
 *   /pricing                            9-tier pricing + Trustee-Grade
 *   /about                              About
 *   /contact                            Contact (email + demo path)
 *
 *   Segments (4):
 *   /for-auction-houses                 Traditional auctioneers
 *   /for-facilities                     Lien-law verticals
 *   /for-liquidators                    Business liquidation
 *   /for-specialty                      Live commerce / specialty
 *
 *   LIVE niches (4):
 *   /estate-auction-software            Estate
 *   /antique-auction-software           Antique
 *   /collectibles-auction-software      Collectibles
 *   /storage-auction-software           Storage (+ LockerBids cross-link)
 *
 *   Feature deep-dives (2):
 *   /features/lien-law-compliance       Compliance engine
 *   /features/bidding-engine            Atomic place_bid story
 *
 *   Case study:
 *   /case-studies/dta                   Discount Tool Auctions
 *
 *   *                                   NotFound
 */
export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />

        <Route path="for-auction-houses" element={<ForAuctionHouses />} />
        <Route path="for-facilities" element={<ForFacilities />} />
        <Route path="for-liquidators" element={<ForLiquidators />} />
        <Route path="for-specialty" element={<ForSpecialty />} />

        <Route path="estate-auction-software" element={<EstateAuctionSoftware />} />
        <Route path="antique-auction-software" element={<AntiqueAuctionSoftware />} />
        <Route path="collectibles-auction-software" element={<CollectiblesAuctionSoftware />} />
        <Route path="storage-auction-software" element={<StorageAuctionSoftware />} />

        <Route path="features/lien-law-compliance" element={<LienLawCompliance />} />
        <Route path="features/bidding-engine" element={<BiddingEngine />} />

        <Route path="case-studies/dta" element={<CaseStudyDta />} />

        <Route path="privacy" element={<Privacy />} />
        <Route path="terms" element={<Terms />} />
        <Route path="subscriber-agreement" element={<SubscriberAgreement />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
